import { TextField } from '@mui/material';
import type { ReactElement } from 'react';
import type { IInputFieldProps } from '../../../types';

/**
 * This component returns JSX element
 * @param {IInputFieldProps} props Input field Props
 * @returns {React.JSX.Element} Text field
 */
export const TextFieldInput = (props: IInputFieldProps): ReactElement => {
  return (
    <TextField
      id={props.code + '-textfield'}
      size={props.size}
      fullWidth
      label={props.label}
      variant="outlined"
      onChange={(event): void => props.handleInputChange(props.code, event.target.value)}
      disabled={props.disabled}
      value={props.value ? props.value : ''}
      slotProps={{ inputLabel: { className: props.isRequired ? 'required' : undefined } }}
    />
  );
};
